import { defineMessages } from "react-intl";

const CONFIRM_MERGE_MODAL = "confirm-merge-modal";

const confirmMergeModalMessages = defineMessages({
  continueWithMerge: {
    id: `${CONFIRM_MERGE_MODAL}.continue-with-merge`,
    defaultMessage: "Continue with merge?",
    description: "Modal header"
  },
  deletionWarning: {
    id: `${CONFIRM_MERGE_MODAL}.deletion-warning`,
    defaultMessage:
      "Merging this data will result in the deletion of your <styledUsername>{sourceAccountUsername}</styledUsername> account."
  }
});

export default confirmMergeModalMessages;
